import { FlowType, SourceType } from './analytics';

export const COMPONENT = 'nocodenodeweb';
export const SPACE_KEY = 'SKS09G';
export const PRODUCT = 'quantum_leap';
export const FPTI_GROUP = 'main:business:web:hostedcheckout';
export const fptiPageNames = {
  payment: 'main:business:web:hostedcheckout:payment',
  order_status: 'main:business:web:hostedcheckout:order_status',
  not_found: 'main:business:web:hostedcheckout:not_found',
  merchant_website: 'main:business:web:hostedcheckout:merchant_website',
  subscriptions: 'main:business:web:hostedcheckout:subscriptions' // TODO-SERVICES: engage with analytics team to decide which group subscriptions will belong
};

export type FtpiType = {
  sourceType?: SourceType;
  flowType?: FlowType;
};

export const extractSourceAndFlowType = (ftpi: FtpiType | undefined) => {
  return { sourceType: ftpi?.sourceType ?? 'unknown', flowType: ftpi?.flowType ?? 'unknown' };
};
